export default __webpack_public_path__ + "static/media/CPAP-Image.41a78015.png";